import React, { Fragment } from 'react';
import moment from 'moment';
import TimeOffInformation from './TimeOffInformation';
import './WeekOverview.css';

const ShiftInformation = ({ shifts, approvedTimeOff, rejectedTimeOff, totalBreakMintuesForDay }) => {
  const formatTime = date => moment(date).format('h:mm A');
  const approvedTimeOffObject = approvedTimeOff.length === 1 ? approvedTimeOff[0] : null;
  const rejectedTimeOffObject = rejectedTimeOff.length === 1 ? rejectedTimeOff[0] : null;

  return (shifts.length === 0 && approvedTimeOff.length === 0 && rejectedTimeOff.length === 0
    ? <div style={{ marginTop: 8 }}>
      <span className='shift-main-text'>Not Scheduled</span>
    </div>
    : <Fragment>
      <div className='shifts-container'>
        <div style={{ marginTop: 8 }}>
          { approvedTimeOffObject && <TimeOffInformation type='approve' timeOffInfo={approvedTimeOffObject} /> }
          { rejectedTimeOffObject && <TimeOffInformation type='reject' timeOffInfo={rejectedTimeOffObject} /> }
          { shifts.length > 0 && shifts.map((shift, index) => (
            <span key={index} className='shift-main-text' style={{ display: 'block' }}>{formatTime(shift.start)} - {formatTime(shift.end)}</span>
          ))}
          { shifts.length > 0 &&
            <div style={{ marginTop: 16, marginBottom: 16 }}>
              <span className='shift-secondary-text'>Break</span>
              <span className='shift-main-text'>({totalBreakMintuesForDay} minutes)</span>
            </div>
          }
        </div>
      </div>
    </Fragment>
  );
};

export default ShiftInformation;
